// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pKEQTdBP9gpygIdLMbm5{position:relative;min-height:50vh}`, "",{"version":3,"sources":["webpack://./src/app/config/routes/private.route.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,eAAA","sourcesContent":[".route-shell {\n  position: relative;\n  min-height: 50vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"route-shell": `pKEQTdBP9gpygIdLMbm5`
};
export default ___CSS_LOADER_EXPORT___;
